export default __webpack_public_path__ + "static/media/4.8d3a7b90.png";